// extracted by mini-css-extract-plugin
export default {"actionContentBox":"shiftManagement_actionContentBox__QnTBu"};